import { styled, component } from '../../../utils/style';

export const StyledDriveItemInfoButton = styled()(component.div, 'StyledDriveItemInfoButton')`
	cursor: pointer;
	flex-shrink: 0;
	height: 30px;
	width: 30px;

	& > svg {
		height: 100%;
		width: 100%;
		transition: all 0.2s;
		fill: ${props => props.theme.primary.strongColor};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/InfoButton/styles.ts